export default "__VITE_ASSET__Q2f6DVlFyPsOk$b2Q3trRA__";